'use client';

import { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './HeroSplitScreen.module.css';

interface ServiceCardData {
    id: string;
    number: string;
    title: string;
    description: string;
    features: string[];
    className: string;
    link: string;
}

const servicesData: ServiceCardData[] = [
    {
        id: 'mainland',
        number: '01',
        title: 'Mainland',
        description: 'Trade freely within the UAE and internationally. No restrictions on business activities or location.',
        features: ['100% Foreign Ownership', 'Government Contracts', 'Unlimited Visas'],
        className: styles.cardMainland,
        link: '/business-setup/mainland',
    },
    {
        id: 'freezone',
        number: '02',
        title: 'Freezone',
        description: 'Cost-effective setup with tax exemptions. Ideal for digital businesses, trading, and consultancy.',
        features: ['0% Personal Tax', 'Full Profit Repatriation', 'Quick Setup'],
        className: styles.cardFreezone,
        link: '/business-setup/freezone',
    },
    {
        id: 'offshore',
        number: '03',
        title: 'Offshore',
        description: 'Protect your assets and manage international wealth without a physical presence in the UAE.',
        features: ['Asset Protection', 'International Trading', 'Multi-Currency Accounts'],
        className: styles.cardOffshore,
        link: '/business-setup/offshore',
    },
];

export default function HeroSplitScreen() {
    const [activeCard, setActiveCard] = useState<string>('freezone');

    const handleCardClick = (id: string) => {
        setActiveCard(id);
    };

    return (
        <div className={styles.screenContainer}>
            {/* LEFT: Info Panel */}
            <div className={styles.infoPanel}>


                <h1 className={styles.mainTitle}>
                    Business Setup in UAE<br />
                    <span>Mainland, Freezone & Offshore</span>
                </h1>

                <p className={styles.mainDesc}>
                    Launch your company in the UAE with licensed advisors, transparent pricing, and real office solutions. From trade license to bank account, visas, accounting, and office space — RotanaBiz handles everything under one roof.
                </p>

                <div className={styles.ctaBox}>
                    <Link to="/contact" className={`${styles.btn} ${styles.btnGreen}`}>
                        Speak to Advisor
                    </Link>
                    <Link to="/business-setup/freezone/cost-calculator" className={`${styles.btn} ${styles.btnOutline}`}>
                        Get Instant Quote
                    </Link>
                </div>

                <div className={styles.statsRow}>
                    <div className={styles.stat}>
                        <h4>10<span>+</span></h4>
                        <p>Years Experience</p>
                    </div>
                    <div className={styles.stat}>
                        <h4>400<span>+</span></h4>
                        <p>Coworking Seats</p>
                    </div>
                    <div className={styles.stat}>
                        <h4>50<span>+</span></h4>
                        <p>Private Offices</p>
                    </div>
                </div>
            </div>

            {/* RIGHT: Interactive Service Cards */}
            <div className={styles.servicesWrapper}>
                {servicesData.map((service) => (
                    <div
                        key={service.id}
                        className={`${styles.serviceCard} ${service.className} ${activeCard === service.id ? styles.active : ''}`}
                        onClick={() => handleCardClick(service.id)}
                    >
                        <span className={styles.cardNumber}>{service.number}</span>
                        <div className={styles.cardContent}>
                            <h3 className={styles.cardTitleVertical}>{service.title}</h3>
                            <h3 className={styles.cardTitleHorizontal}>{service.title}</h3>
                            <div className={styles.cardDetails}>
                                <p>{service.description}</p>
                                <ul>
                                    {service.features.map((feature, index) => (
                                        <li key={index}>{feature}</li>
                                    ))}
                                </ul>
                                <Link
                                    to={service.link}
                                    className={`${styles.btn} ${styles.btnGreen}`}
                                    style={{
                                        marginTop: '1.5rem',
                                        padding: '0.75rem 1.5rem',
                                        fontSize: '0.9rem',
                                        width: 'fit-content'
                                    }}
                                >
                                    Explore {service.title}
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
